import { SecurityGuardRuleInterface } from '../../../security/guard/rule.interface';
import { WindowLocationServiceInterface } from '../../../../service/window-location/service.interface';

/**
 * Checks that the window location hostname is whitelisted
 */
export class StatsGuardRuleHostname implements SecurityGuardRuleInterface {
  /**
   * Whitelisted domain names (and all their subdomains) that can send stats
   *
   * TODO-FE[later] Consider making the list configurable on runtime per project
   */
  public static readonly DOMAIN: string[] = [
    'propertyfinder.ae',
    'propertyfinder.qa',
    'propertyfinder.bh',
    'propertyfinder.eg',
    'propertyfinder.com.lb',
    'sarouty.ma',
    'esimsar.com', // TODO[WEB-5841] Remove this domain
    'propertyfinder.sa',
    'propertyfinder.net',
  ];

  /**
   * Constructor
   */
  constructor(private windowLocationService: WindowLocationServiceInterface) {}

  /**
   * @inheritDoc
   */
  public isRespected(): boolean {
    const windowHostname = this.windowLocationService.getHostname();

    return StatsGuardRuleHostname.DOMAIN.some((domain) => {
      return windowHostname.substr(-domain.length) === domain;
    });
  }
}
